const t = require('gorko.translator');

module.exports = t;
